<template>
  <el-dialog
    :visible="localVisible"
    :title="(isCreateNewVessel ? 'Create New ' : 'Modify ') + getLabel"
    :width="isSts? '600px':'500px'"
    @close="handleCloseDialog"
  >
    <div>
      <el-form ref="vesselFormRef" :model="vesselForm" :rules="computedRules" :label-width="isSts?'170px':'120px'" label-position="left">
        <el-form-item :label="getLabel + ' Name:'" prop="vesselName">
          <el-input v-model="vesselForm.vesselName" placeholder="Enter vessel name" />
          <div
            v-if="selectedVessel"
            class="warning-message"     
          >
            <div v-if="selectedVessel.lastSyncedMpaBargeFound || selectedVessel.lastSyncedMpaVesselFound">
              Exist in MPA
            </div>
            <div v-else-if="selectedVessel.lastSyncedMpaBargeFound === false && selectedVessel.lastSyncedMpaVesselFound === false">
              Not in MPA
            </div>
          </div>
        </el-form-item>

        <el-form-item :label="getLabel + ' IMO:'" prop="vesselImo">
          <el-input 
            v-model="vesselForm.vesselImo" 
            :disabled="disableImo" 
            placeholder="Enter IMO number"
          />
          <div
            v-if="vesselForm.vesselImo && !isValidImoNo(vesselForm.vesselImo)"
            class="warning-message"
          >
            Not a correct format, please check again
          </div>
        </el-form-item>

        <el-form-item :label="'License Number:'" prop="vesselLicenseNo">
          <el-input 
            v-model="vesselForm.vesselLicenseNo" 
            :disabled="disableLicenseNo" 
            placeholder="Enter license number"
          />
          <div
            v-if="licenseFormatError"
            class="warning-message"
          >
            Format: S[A|B|C|P|R|T] NNNNA, please check again
          </div>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button @click="handleCloseDialog()">Cancel</el-button>
      <el-button type="primary" @click="handleSaveVessel" :loading="isSaving">Save</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { getReceivingVesselsBySearch } from "@/services/modules/comm.js";
import { LICENSE_NUMBKER_RULE } from "@/constants.js";
import baseMixin from "@/mixins/base-mixin";
import { isValidImoNo } from "@/utils";
export default {
  name: 'AddVesselDialog',
  props: {
    disabled:Boolean,
    searchedVesselList:Array,
    schedulFormData:Object,
    visible: {
      type: Boolean,
      required: true,
    },
    isCreateNewVessel:Boolean,
    selectedVessel: Object,
    isSts: {
      type: Boolean,
      default: false
    },
  },
  mixins: [baseMixin],
  data () {
    return {
      LICENSE_NUMBKER_RULE,
      localVisible: this.visible,
      vesselSearchKey:'',
      searchLoading:true,
      options:[],
      vesselForm: {
        vesselName: this.isCreateNewVessel ? "" : this.schedulFormData.vesselName,
        vesselImo: this.isCreateNewVessel ? "" : this.schedulFormData.vesselImo|| this.schedulFormData.vesselImoNo,
        vesselLicenseNo: this.isCreateNewVessel ? "" : this.schedulFormData.vesselLicenseNo,
      },
      isSaving: false,
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val;
    },
    localVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  computed: {
    ...mapState({
      currentCompanySettings: "currentCompanySettings",
    }),
    disableImo() {
      const isFromMpa =
        this.selectedVessel?.lastSyncedMpaVesselFound ||
        this.selectedVessel?.lastSyncedMpaBargeFound;

      const hasImo = !!this.selectedVessel?.imo;

      if (!isFromMpa) return false;
      if (hasImo) return true;
      return false;
    },
    disableLicenseNo() {
      const isFromMpa =
        this.selectedVessel?.lastSyncedMpaVesselFound ||
        this.selectedVessel?.lastSyncedMpaBargeFound;
      const hasLicenceNo = !!this.selectedVessel?.licenceNo
      if (!isFromMpa) return false;
      if (hasLicenceNo) return true;
      return false;
    },
    computedRules() {
      return {
        vesselName: [{ required: true, message: 'Vessel name is required', trigger: 'manual' }],
        vesselImo: this.disableImo ? [] : [{ validator: this.validateIMO, trigger: 'manual' }],
        vesselLicenseNo: this.disableLicenseNo ? [] : [{ validator: this.validateLicense, trigger: 'manual' }]
      };
    },
    getLabel(){
      return this.isSts? 'Receiving Barge' : 'Vessel'
    },
    licenseFormatError() {
      const value = this.vesselForm?.vesselLicenseNo || '';
      const pattern = LICENSE_NUMBKER_RULE[0]?.pattern;
      return value && !pattern.test(value);
    }
  },
  mounted(){
    // console.log("d",this.schedulFormData)
  },
  methods: {
    isValidImoNo,
    handleCloseDialog(){
      this.localVisible = false;
    },
    handleSaveVessel(){
      this.isSaving = true;
      this.$refs.vesselFormRef.validate((valid, fields) => {
        this.isSaving = false;
        if (valid) {
          this.$emit('save', this.vesselForm);
          this.localVisible = false;
          return;
        }

        const fieldsToValidate = ['vesselName'];
        if (this.isCreateNewVessel || !this.disableImo) {
          fieldsToValidate.push('vesselImo');
        }
        if (this.isCreateNewVessel || !this.disableLicenseNo) {
          fieldsToValidate.push('vesselLicenseNo');
        }
        const hasError = fieldsToValidate.some(field => fields[field]);
        if (!hasError) {
          this.$emit('save', this.vesselForm);
          this.localVisible = false;
        }
      });
    },
    async validateIMO(rule, value, callback) {
      if (!value) return callback();
      const companyId =
        this.currentCompanySettings.canFilterSearchByCompanyId &&
        this.cashType && this.cashType == "non-cash"
          ? this.schedulFormData.buyerSysOrganizationId
          : null;
      try {
        const res = await getReceivingVesselsBySearch({imoNo: value});
        const list = res?.data?.records || [];
        const matched = list.find(item => item.imo === value);
        if (matched) {
          const shipName = matched.shipName || '';
          callback(new Error(`IMO number already exists in database: ${shipName}`));
        } else {
          callback();
        }
      } catch (e) {
        callback();
      }
    },
    async validateLicense(rule, value, callback) {
      if (!value) return callback();
      const companyId =
        this.currentCompanySettings.canFilterSearchByCompanyId &&
        this.cashType && this.cashType == "non-cash"
          ? this.schedulFormData.buyerSysOrganizationId
          : null;
      try {
        const res = await getReceivingVesselsBySearch({licenseNo: value});
        const list = res?.data?.records || [];
        const matched = list.find(item => item.licenceNo === value);
        if (matched) {
          const shipName = matched.shipName || '';
          callback(new Error(`License number already exists in database: ${shipName}`));
        } else {
          callback();
        }
      } catch (e) {
        callback();
      }
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-dialog {
  height: 300px !important;
}
/deep/.el-dialog__body{
  height: 130px !important;
  // overflow-y: auto;
}
.warning-message {
  color: #256BC3; 
  font-size: 10px; 
  margin: -10px 0px;
}
</style>
